module.exports = __webpack_public_path__ + "img/almost_funded_large.149393e6.png";